<div class="form-panel-container">
    <form [formGroup]="formGroup">
        <div class="form-container" [ngClass]="{ readonly: _context?.mode === FormMode.Reading }">
            @if (_context.mode !== FormMode.Creation) {
                <ng-container class="fieldset">
                    <div class="form-item">
                        <mat-form-field>
                            <mat-label>Nom</mat-label>
                            <input matInput data-input-name type="text" formControlName="name" autocomplete="off" required />
                        </mat-form-field>
                    </div>
                    @if (!isOrganizationRoot) {
                        <div class="form-item">
                            <mat-form-field>
                                <mat-label>Groupe parent</mat-label>
                                <mat-select data-select-parentGroupId formControlName="parentGroupId" required>
                                    @for (groupParent of groupParents; track groupParent) {
                                        <mat-option data-select-listing-type-option [value]="groupParent.id">
                                            {{ groupParent.name }}
                                        </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        </div>
                    }
                </ng-container>
            }
            @if (!isOrganizationRoot) {
                <div class="form-item">
                    <mat-form-field>
                        <mat-label>Rôles</mat-label>
                        <mat-select data-select-roles formControlName="roles" multiple #roleselect>
                            @for (role of roles; track role) {
                                <mat-option data-select-listing-type-option [value]="role.id">
                                    {{ role.name }}
                                </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    @if (formGroupErrors?.roles?.required && (formGroup.controls['roles']?.dirty || formGroup.controls['roles'].touched)) {
                        <mat-error data-input-title-error>Le champ 'Rôles' est obligatoire</mat-error>
                    }
                </div>
            }
        </div>
    </form>

    <div class="buttons-container">
        <button mat-stroked-button class="accent-button" [disabled]="formGroup.disabled" [ngClass]="{ disabled: formGroup.invalid || formGroup.disabled }" (click)="cancel()">
            Annuler
        </button>
        <button
            mat-raised-button
            class="accent-button"
            [disabled]="formGroup.disabled || formGroup.invalid || formValuesChanges === false || userRolesModifyRight === false"
            [ngClass]="{ disabled: formGroup.invalid || formGroup.disabled || userRolesModifyRight === false }"
            (click)="manualSave()">
            Enregistrer
        </button>
    </div>
</div>
